<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>公文管理</el-breadcrumb-item>
      <el-breadcrumb-item>快捷短语</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-button type="primary" @click="addList"> +添加</el-button>
      <el-button type="primary" @click="delesList"> 删除</el-button>
      <div v-if="phas">
        <el-cascader
          v-model="value"
          :options="options"
          @change="handleChange"
          ref="demoCascader"
        >
        </el-cascader>
        <input
          class="inputss"
          type="text"
          placeholder="请输入内容"
          v-model="Shortcut"
        />
        <el-button type="primary" class="btn_1" @click="placbtn"
          >确定</el-button
        >
      </div>
      <el-divider></el-divider>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="id" label="序号" width="180"> </el-table-column>
        <el-table-column prop="createTime" label="日期" width="180">
        </el-table-column>
        <el-table-column prop="oneCatalogue" label="一级路由" width="180">
        </el-table-column>
        <el-table-column
          prop="twoCatalogue"
          label="二级路由"
          width="180"
        ></el-table-column>
        <el-table-column prop="phrase" label="内容"> </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button @click="delecClick(scope.row)" type="text" size="small"
              >删除</el-button>
            <el-button @click="editClick(scope.row)" type="text" size="small"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 编辑弹出层 -->
    <el-dialog @opened="openedDialog" title="编辑" @close="cancel" :visible.sync="centerDialogVisible" width="70%" center>
      <div style="display: flex;align-items: center;">
        <!-- 知情同意书模板 -->
        <div style="margin-bottom:60px;flex:1;">
          <div class="dialogItem" style="display: flex;align-items: center;">
            <div class="title">知情同意书模板:</div>
            <div>
              <el-upload :action="imgurl" :on-success="handleAvatarSuccess"
                :file-list="fileList" accept=".pdf">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </div>
          </div>
          <!-- 描述文字 -->
          <div style="font-size:14px;color:red;">
            *知情同意书模板仅能上传PDF文件，用于患者在病例创建时签署在线电子合同
          </div>
        </div>
        <!-- PDF预览 -->
        <div v-show="pdfh5">
          <div>
            <div style="height: 500px;"  @dblclick="zoomOut" id="preViewPdf" ></div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisibleSubmit">
          确定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pdfh5 from "pdfh5";

export default {
  data() {
    return {
      imgurl: 'https://www.idemer.com/web/upload/uploadVideo',
      phas: false,
      Shortcut: "",
      value: [],
      onelogue: "",
      twologue: "",
      options: [
        {
          value: "1",
          label: "患者管理",
          children: [
            {
              value: "1",
              label: "主诉",
            },
            {
              value: "2",
              label: "现病史",
            },
            {
              value: "3",
              label: "口腔检查",
            },
            {
              value: "4",
              label: "诊断",
            },
            {
              value: "5",
              label: "处置",
            },
          ],
        },
        {
          value: "收费管理",
          label: "收费管理",
          children: [
            {
              value: "2",
              label: "1111",
            },
          ],
        },
      ],
      tableData: [],
      currentEditItem: null, // 当前编辑项
      centerDialogVisible: false, // 编辑弹出层开关
      fileList: [],// 模板文件列表
      pdfh5: null, // pdf预览实例
    };
  },
  created() {
    this.InfoList();
  },
  computed: {},
  methods: {
    // 双击跳转新页面预览
    zoomOut(){
      window.open(this.currentEditItem.pdfUrl);
    },
    // 打开PDF预览
    openPdf(url) {
      this.$nextTick(() => {
        this.pdfh5 = new Pdfh5("#preViewPdf", {
          pdfurl: url,
          scale: 0.7,
        });
        // 监听pdf渲染成功
        this.pdfh5.on("success", (msg,time) => {
          console.log( "监听pdf渲染成功",msg,time);
        });
      });
    },
    // 上传知情同意书模板成功
    handleAvatarSuccess(res, file, fileList) {
      this.fileList = [file];
      console.log(res, file, fileList);
    },
    // 编辑弹出层关闭
    cancel() {
      this.centerDialogVisible = false;
      this.currentEditItem = null;
      this.pdfh5 = null;
      this.fileList = [];
    },
    // 编辑弹出层确定
    centerDialogVisibleSubmit() {
      if (!this.fileList[0].response) {
        this.$message.warning("请上传知情同意书模板");
      } else {
        this.$http.post(`/phrase/update`, {
            id: this.currentEditItem.id,
            pdfUrl: this.fileList[0].response,
          }).then((res) => {
            this.cancel();
            this.$message.success("编辑成功");
            this.InfoList();
          });
      }
    },
    // 点击编辑按钮
    editClick(item) {
      this.currentEditItem = item;
      this.centerDialogVisible = true;
    },
    // 缓存弹出层打开时调用
    openedDialog() {
      if(this.currentEditItem.pdfUrl){
        this.pdfh5 = null;
       this.$nextTick(() => {
        this.openPdf(this.currentEditItem.pdfUrl);
       })
      }
    },
    delesList() {
      //  for (let  i = 0; i < 5; i++) {
      //  console.log(i,12);
      //  setTimeout(function(){
      //    console.log(i);
      //  })}

      for (var i = 0; i < 5; i++) {
        console.log(i, 12);
        setTimeout(function() {
          console.log(i);
        }, 2);
      }
    },
    delecClick(e) {
      let id = e.id;
      console.log(id);
      this.$http.post(`/phrase/delete?id=` + id).then((res) => {
        this.$message.success(res.data.data);
        this.$router.go(0);
      });
    },
    InfoList() {
      this.$http
        .post(`/phrase/select`, {
          id: 1,
        })
        .then((res) => {
          console.log(res, 40);
          for (let i = 0; i < res.data.data.length; i++) {
            if (res.data.data[i].oneCatalogue === "1") {
              res.data.data[i].oneCatalogue = "患者管理";
            } else {
              res.data.data[i].oneCatalogue = "收费管理";
            }
            if (res.data.data[i].twoCatalogue === "1") {
              res.data.data[i].twoCatalogue = "主诉";
            } else if (res.data.data[i].twoCatalogue === "2") {
              res.data.data[i].twoCatalogue = "现病史";
            } else if (res.data.data[i].twoCatalogue === "3") {
              res.data.data[i].twoCatalogue = "口腔检查";
            } else if (res.data.data[i].twoCatalogue === "4") {
              res.data.data[i].twoCatalogue = "诊断";
            } else {
              res.data.data[i].twoCatalogue = "处置";
            }
          }
          this.tableData = res.data.data;
        });
    },
    addList() {
      this.phas = true;
    },
    // 点击添加快捷短语
    placbtn() {
      // this.phas = false;
      if (this.twologue == "" && this.Shortcut == "") {
        this.$message.warning("请填写内容");
      } else {
        this.$http
          .post(`/phrase/insert`, {
            oneCatalogue: this.onelogue,
            twoCatalogue: this.twologue,
            phrase: this.Shortcut,
          })
          .then((res) => {
            this.$message.success("添加成功");
            this.$router.go(0);
          });
      }
    },
    handleChange(value) {
      this.onelogue = value[0];
      this.twologue = value[1];
    },
  },
};
</script>

<style scoped>
/deep/.viewerContainer {
  overflow: visible !important;
}
#preViewPdf {
  background: #ebeef5 !important;
}
.inputss {
  width: 400px;
  height: 60px;
  margin-top: 25px;
  margin-left: 20px;
  border-radius: 5px;
  border: 1px solid#DCDFE6;
}
.btn_1 {
  margin-left: 15px;
}
</style>
